import { BoxPlotFilled, BoxPlotOutlined, BoxPlotTwoTone } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import { DisplayState } from '../CsmSensePage';

type SensorAggregationProps = {
  showCurves: DisplayState;
  setMziUplotOptions: React.Dispatch<React.SetStateAction<uPlot.Options | null>>;
  setMziUplotData: React.Dispatch<React.SetStateAction<uPlot.AlignedData>>;
  setShouldAggregate: React.Dispatch<React.SetStateAction<boolean>>;
  setShouldRedraw: React.Dispatch<React.SetStateAction<boolean>>;
  setShowCurves: React.Dispatch<React.SetStateAction<DisplayState>>;
};

const SensorAggregation: React.FC<SensorAggregationProps> = ({ showCurves, setMziUplotOptions, setMziUplotData, setShouldAggregate, setShouldRedraw, setShowCurves }) => {
  return (
    <Tooltip
      overlayInnerStyle={{
        textAlign: 'center',
      }}
      overlay="Toggle sensor aggregation"
    >
      <Button
        type="text"
        size="large"
        onClick={() => {
          setMziUplotOptions(null);
          setMziUplotData([]);
          switch (showCurves) {
            case DisplayState.AggregatedCurves:
              setShouldAggregate(false);
              setShowCurves(DisplayState.UnaggregatedCurves);
              setShouldRedraw(true);
              break;
            case DisplayState.UnaggregatedCurves:
              setShouldAggregate(true);
              setShowCurves(DisplayState.MedianOnly);
              setShouldRedraw(true);
              break;
            case DisplayState.MedianOnly:
              setShouldAggregate(true);
              setShowCurves(DisplayState.AggregatedCurves);
              setShouldRedraw(true);
              break;
            default:
              console.log('error');
          }
        }}
        icon={(() => {
          switch (showCurves) {
            case DisplayState.AggregatedCurves:
              return <BoxPlotTwoTone />;
            case DisplayState.UnaggregatedCurves:
              return <BoxPlotOutlined />;
            case DisplayState.MedianOnly:
              return <BoxPlotFilled />;
          }
        })()}
      />
    </Tooltip>
  );
};

export default SensorAggregation;
